import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useInterviewSession } from '../hooks/useInterviewSession';
import InterviewIntro from '../components/interview/InterviewIntro';
import InterviewQuestion from '../components/interview/InterviewQuestion';
import InterviewComplete from '../components/interview/InterviewComplete';

export default function InterviewPage() {
  const { applicationId } = useParams();
  const navigate = useNavigate();
  const {
    phase,
    session,
    currentQuestion,
    result,
    error,
    start,
    loadNextQuestion,
    submitAnswer,
  } = useInterviewSession();

  useEffect(() => {
    if (phase === 'idle' && applicationId) {
      start(applicationId);
    }
  }, [phase, applicationId, start]);

  return (
    <div className="min-h-screen bg-white py-10 px-4">
      {phase === 'loading' && (
        <div className="text-center py-20 text-[#1b5e20]">
          <div className="animate-pulse text-lg font-medium">Preparing your interview...</div>
        </div>
      )}

      {phase === 'error' && (
        <div className="max-w-xl mx-auto p-6 bg-red-50 border border-red-200 rounded-lg">
          <h2 className="font-bold text-red-700 mb-2">Something went wrong</h2>
          <p className="text-red-700 mb-4">{error}</p>
          <button
            onClick={() => navigate('/jobs')}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
          >
            Back to Jobs
          </button>
        </div>
      )}

      {phase === 'intro' && <InterviewIntro session={session} onBegin={loadNextQuestion} />}

      {(phase === 'question' || phase === 'submitting') && currentQuestion && (
        <InterviewQuestion
          question={currentQuestion}
          session={session}
          onSubmit={submitAnswer}
          submitting={phase === 'submitting'}
        />
      )}

      {phase === 'completing' && (
        <div className="text-center py-20 text-[#1b5e20]">
          <div className="animate-pulse text-lg font-medium">
            Generating your evaluation report...
          </div>
          <div className="text-sm text-gray-500 mt-2">This may take up to 30 seconds.</div>
        </div>
      )}

      {phase === 'complete' && <InterviewComplete result={result} />}
    </div>
  );
}
